export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.87599931.jpg";